import * as dd from 'dingtalk-jsapi'
import { noticeDing } from '@/services/api'
export function getCode(callback, corpId, companyId, staffId) {
  if (dd.env.platform != 'notInDingTalk') {
    dd.ready(() => {
      //使用SDK 获取免登授权码
      dd.runtime.permission.requestAuthCode({
        corpId,
        onSuccess: info => {
          callback(info.code)
          if (companyId) {
            noticeDing({
              companyId,
              staffId,
              authCode: info.code,
            })
          }
        },
        onFail: err => {
          alert(JSON.stringify(err))
        },
      })
    })
  }
}

//DD分享
export function shareDD(option) {
  if (dd.env.platform != 'notInDingTalk') {
    dd.ready(() => {
      dd.biz.util.share({
        type: 0,
        url: option.shareUrl,
        title: option.shareTitle,
        content: option.shareDesc,
        image: option.shareImg,
        onSuccess: function () {
          // 调用成功时回调
        },
        onFail: function (err) {
          console.log(err)
        },
      })
    })
  }
}

//是否在钉钉环境
export function ifInDD() {
  if (dd.env.platform != 'notInDingTalk') {
    return true
  } else {
    return false
  }
}
